import React from "react";

import * as moment from "moment";

import { Feed, Icon, Popup } from "semantic-ui-react";

import { connect } from "react-redux";

import { requestOpenPaymentModal } from "../actions/reimbursements";

const kindToDetails = {
    cash: {
        icon: 'money bill alternate',
        color: 'green',
        message: (payment) => (<span>{ payment.payer } paid ${ payment.amount } to { payment.paid_to.name } in cash.</span>)
    },
    check: {
        icon: 'university',
        color: 'grey',
        message: (payment) => (
            <span>
                { payment.payer } wrote a check{ (payment.check_number) ? (<span> (#{ payment.check_number })</span>) : "" } for ${ payment.amount } to { payment.paid_to.name }.
            </span>
        )
    }
}

const PaymentLogItem = props => {
  const payment = props.payment;
  const modal = (
    <a onClick={() => props.requestOpenModal(payment.uuid)}>
      More details.
    </a>
  );
  const details = kindToDetails[payment.kind];
  return (
    <Feed.Event>
      <Feed.Label>
        <Icon name={details.icon} color={details.color} />
      </Feed.Label>
      <Feed.Content>
        <Feed.Summary>
          { details.message(payment) } { modal }
          <Feed.Date>
            <Popup
              size="mini"
              inverted
              trigger={<span>{moment(payment.created_at).calendar()}</span>}
              content={moment(payment.created_at).format("llll")}
            />
          </Feed.Date>
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
  );
};

const mapDispatchToProps = dispatch => ({
  requestOpenModal: paymentUUID =>
    dispatch(requestOpenPaymentModal(paymentUUID))
});

const ConnectedPaymentLogItem = connect(
  null,
  mapDispatchToProps
)(PaymentLogItem);

const PaymentLog = props => (
  <Feed>
    {props.payments.map(payment => (
      <ConnectedPaymentLogItem
        payment={payment}
        key={payment.uuid}
      />
    ))}
    {props.payments.length === 0 && <div>There are no payments to show</div>}
  </Feed>
);

export default PaymentLog;



// WEBPACK FOOTER //
// ./frontend/src/components/PaymentLog.js